import { NgModule, ErrorHandler } from '@angular/core';
import { IonicModule, IonicErrorHandler } from 'ionic-angular';
import { PageRef } from '../../core/core.module';
import { CouponsPage} from './pages/coupons/coupons';
import { CouponsPageFull } from './pages/coupons/coupons.full';
//
export { CouponsPage} from './pages/coupons/coupons';
export { CouponsPageFull } from './pages/coupons/coupons.full';

@NgModule({
	imports: [
		IonicModule
	],
	declarations: [
        CouponsPage,
        CouponsPageFull
    ],
    exports: [
        CouponsPage,
        CouponsPageFull
    ],
    bootstrap: [],
    entryComponents: [
        CouponsPage,
        CouponsPageFull
    ],
    providers: [{provide: ErrorHandler, useClass: IonicErrorHandler}]
})
export class CouponsModule{
	constructor(public pageRef: PageRef){
       this.pageRef.addCfgLinks([
            { component: CouponsPage, fullComponent: CouponsPageFull, name: 'Coupons Page', segment: 'coupons' }
        ]) 
    }

}


// WEBPACK FOOTER //
// ./src/modules/coupons/coupons.module.ts